// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js'
import Toast from './components/Toast'
import { share, wxConfig } from './utils/share'
import { getPara } from './utils/url'
import Bridge from './config/JSbridge.js'
import vconsole from './utils/vconsole'
import './utils/filter'
import utils from './utils'
// 引入sentry
// import './utils/sentry'

// ydUserId作为公参已经在sendLoginInfo函数中同步，私参数请不要再加了，否则会删除掉
import reportToRlog from './utils/rlog'

// if (process.env.NODE_ENV == 'development') {
//   require('./mock/index')
// }
// eslint-disable-next-line no-undef
if (VCONSOLE_SHOW) {
  vconsole()
}

// if (typeof DATracker == 'undefined') {
window.DATracker = {
  track: function () { },
  login: function () { },
  logout: function () { }
}
// DATracker.init('MA-801B-F49D776BEEDA', {
//   track_pageview: false,
//   debug: true,
//   truncateLength: 255,
//   persistence: 'localStorage',
//   cross_subdomain_cookie: false
// })
// DATracker.register_attributes({
//   outVender: getPara('outVender') || ''
// })
// }

// debugger
// 微信分享兼容写法
window.ydk = {}
window.ydk.share = share
wxConfig()
// rlog日志接口
window.reportToRlog = reportToRlog

Vue.prototype.$toast = function (text, tm = 2000) {
  const el = document.createElement('div')
  const toast = new (Vue.extend(Toast))({
    propsData: {
      toastText: text
    }
  })
  document.body.appendChild(el)
  toast.$mount(el)
  setTimeout(() => {
    var parent = toast.$el.parentNode
    if (parent) {
      parent.removeChild(toast.$el)
    }
    toast.$destroy()
  }, tm)
}

router.beforeEach(async (to, from, next) => {
  document.title =
    to.meta.title ||
    (utils.isIreadingDomain() ? '有道天天读' : '有道开口读') ||
    '有道天天读'
  next()
})
Vue.config.ignoredElements = ['wx-open-launch-app']
Vue.prototype.$bridge = Bridge
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
